import { combineReducers } from 'redux';
import gameReducer from './gameReducer';

const Game = combineReducers({
  gameReducer,
})

export default Game